export default function CheckBox({
  isChecked,
  text,
  isDisabled = false,
  onChange,
  error,
}) {
  return (
    <div className="flex items-center justify-start gap-2">
      <input
        className={`${error ? "outline-none outline-1 outline-red-500 ml-1" : ""}`}
        type="checkbox"
        checked={isChecked}
        onChange={onChange}
        disabled={isDisabled}
      />
      {text && text}
    </div>
  );
}
